import { format } from "date-fns";
import { SERVICES } from "@/lib/api";

const Row = ({ k, v, testid }) => (
  <div className="flex items-baseline justify-between gap-4 border-b border-dashed border-white/10 py-3">
    <span className="eyebrow">{k}</span>
    <span className="text-right text-sm font-semibold text-zinc-100" data-testid={testid}>{v || "—"}</span>
  </div>
);

import { timeLabel } from "@/lib/api";

export const Summary = ({ serviceId, date, time, step }) => {
  const svc = SERVICES.find((s) => s.id === serviceId);
  return (
    <aside className="clip-notch relative border border-white/10 bg-[#111317] p-7" data-testid="booking-summary">
      <p className="eyebrow text-acid">Your ticket</p>
      <p className="mt-3 font-display text-4xl uppercase leading-none text-zinc-50">The damage</p>
      <div className="mt-6">
        <Row k="Service" v={svc?.name} testid="summary-service" />
        <Row k="Type" v={svc?.category} testid="summary-category" />
        <Row k="Date" v={date ? format(date, "EEE, MMM d yyyy") : ""} testid="summary-date" />
        <Row k="Time" v={timeLabel(time)} testid="summary-time" />
      </div>
      <p className="mt-6 text-xs leading-relaxed text-zinc-400">No payment needed to book. We&apos;ll tailor your quote on a free walkthrough.</p>
      <div className="mt-6 flex gap-1.5">
        {[0, 1, 2].map((i) => <span key={i} className={`h-1 flex-1 transition-colors duration-500 ${i <= step ? "bg-acid" : "bg-white/10"}`} />)}
      </div>
    </aside>
  );
};
